(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 5301:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(1882);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3830:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Logo-01.5e7842b0.svg","height":3000,"width":3000});

/***/ }),

/***/ 4045:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
/* harmony default export */ __webpack_exports__["Z"] = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 3421:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6038);


function useSelector(initialValue) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(initialValue);
    var q = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return gsap__WEBPACK_IMPORTED_MODULE_1__/* ["default"].utils.selector */ .ZP.utils.selector(ref);
    }, [
        ref
    ]);
    return [
        q,
        ref
    ];
}
/* harmony default export */ __webpack_exports__["Z"] = (useSelector);


/***/ }),

/***/ 9265:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6797);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1082);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1911);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6723);
/* harmony import */ var _components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2836);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8352);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(1664);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(1025);









var FeaturedArticles = function(props) {
    var _postTitle, _slug, _type, _outlineColor, _highlightColor;
    var featuredPost = props.posts.map(function(post) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .SwiperSlide */ .o5, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                mx: 4,
                mt: 4,
                mb: 50,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .PostModal */ .lc, {
                    post: post,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components__WEBPACK_IMPORTED_MODULE_4__/* .PostCard */ .y4, {
                        postTitle: (_postTitle = post.postTitle) !== null && _postTitle !== void 0 ? _postTitle : undefined,
                        slug: (_slug = post.slug) !== null && _slug !== void 0 ? _slug : undefined,
                        tag: (_type = post.type) !== null && _type !== void 0 ? _type : undefined,
                        publishDate: post.publishDate,
                        views: post.views,
                        outlineColor: (_outlineColor = post.outlineColor) !== null && _outlineColor !== void 0 ? _outlineColor : undefined,
                        highlightColor: (_highlightColor = post.highlightColor) !== null && _highlightColor !== void 0 ? _highlightColor : undefined
                    })
                })
            })
        }, post.id);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_7__/* .Section */ .$0, {
        id: "featured-articles",
        maxW: "container.xl",
        minH: {
            md: '40vh',
            lg: '40vh'
        },
        pb: {
            base: 20,
            lg: 4
        },
        px: {
            base: 0,
            lg: 4
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
            justify: "center",
            align: "center",
            direction: "column",
            minH: "inherit",
            w: "full",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Grid */ .rj, {
                    display: {
                        base: 'none',
                        md: 'inline-grid'
                    },
                    templateColumns: {
                        base: 'repeat(1,1fr)',
                        md: 'repeat(2,1fr)',
                        lg: 'repeat(3,1fr)'
                    },
                    gap: "10",
                    children: featuredPost
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                    display: {
                        md: 'none'
                    },
                    w: "full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_5__/* .Swiper */ .tq, {
                        spaceBetween: 100,
                        modules: [
                            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Autoplay */ .pt,
                            swiper__WEBPACK_IMPORTED_MODULE_3__/* .Pagination */ .tl
                        ],
                        pagination: {
                            clickable: false
                        },
                        autoplay: {
                            disableOnInteraction: false,
                            delay: 3000
                        },
                        loop: true,
                        children: featuredPost
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                    pt: "20px",
                    pb: {
                        base: '0px',
                        lg: '80px'
                    },
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_6__["default"], {
                        href: "/posts",
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                            id: "blogs-learn-btn",
                            as: "a",
                            size: "lg",
                            children: "View More"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (FeaturedArticles);


/***/ }),

/***/ 1510:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ FeaturedProjects; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./src/components/index.ts + 50 modules
var components = __webpack_require__(2836);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 1 modules
var AnimatePresence = __webpack_require__(5421);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/close-button/dist/chakra-ui-close-button.esm.js
var chakra_ui_close_button_esm = __webpack_require__(4746);
// EXTERNAL MODULE: ./src/assets/images/Logo-01.svg
var Logo_01 = __webpack_require__(3830);
// EXTERNAL MODULE: ./node_modules/lodash/includes.js
var includes = __webpack_require__(4721);
var includes_default = /*#__PURE__*/__webpack_require__.n(includes);
;// CONCATENATED MODULE: ./src/page-components/home/FeaturedProjects/FeaturedProjectsTag.tsx




var FeaturedProjectsTag = function(props) {
    var activeShowcase = (0,components/* useShowcaseStore */.W1)(function(state) {
        return state.activeShowcase;
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
        color: includes_default()(activeShowcase === null || activeShowcase === void 0 ? void 0 : activeShowcase.tags, props.tag) ? activeShowcase === null || activeShowcase === void 0 ? void 0 : activeShowcase.color : 'inherit',
        transitionProperty: "color",
        transitionDuration: ".3s",
        children: props.tag
    });
};
/* harmony default export */ var FeaturedProjects_FeaturedProjectsTag = (FeaturedProjectsTag);

;// CONCATENATED MODULE: ./src/page-components/home/FeaturedProjects/FeaturedProjectsTags.tsx



var FeaturedProjectsTags = function() {
    var wrapItem = {
        initial: {
            opacity: 0,
            scale: 0
        },
        animate: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 1
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* MotionWrap */.Aj, {
        spacing: 16,
        pb: 35,
        justify: "center",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Frontend Development"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Web Design"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "3D Design"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Cloud Computing"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Backend Development"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Hosting Services"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Quality Assurance"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Custom Animations"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Payment Processing"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionWrapItem */.Qn, {
                variants: wrapItem,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTag, {
                    tag: "Booking System"
                })
            })
        ]
    });
};
/* harmony default export */ var FeaturedProjects_FeaturedProjectsTags = (FeaturedProjectsTags);

// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/page-components/home/FeaturedProjects/FeaturedProjects.tsx
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}










var FeatureProjects = function(props) {
    var activeShowcase = (0,components/* useShowcaseStore */.W1)(function(state) {
        return state.activeShowcase;
    });
    var clearActiveShowcase = (0,components/* useShowcaseStore */.W1)(function(state) {
        return state.clearActiveShowcase;
    });
    var ref = (0,react.useState)(false), isInView = ref[0], setIsInView = ref[1];
    var container = {
        initial: {
            opacity: 1
        },
        animate: {
            opacity: 1
        }
    };
    var text = {
        initial: {
            opacity: 0,
            scale: 0,
            transition: {
                duration: 0.5
            }
        },
        animate: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.5
            }
        }
    };
    var defaultText = {
        initial: {
            opacity: 0,
            scale: 0,
            transition: {
                duration: 0.5
            }
        },
        animate: {
            opacity: 1,
            scale: 1,
            transition: {
                duration: 0.5,
                delay: 1.5
            }
        }
    };
    var initialBox = {
        animate: {
            scale: 1,
            transition: {
                duration: 0.5
            }
        },
        exit: {
            scale: 0,
            transition: {
                delay: 1,
                duration: 0.5
            }
        }
    };
    var transition = {
        duration: 1
    };
    var projectItems = props.projects.map(function(project) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ShowcaseItem */.Ys, _objectSpread({}, project), project.id);
    });
    var projectItemsMobile = props.projects.map(function(project) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* LinkBox */.fG, {
            w: "100%",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                    position: "relative",
                    w: "100%",
                    height: {
                        base: '160px',
                        xs: '280px',
                        sm: '420px',
                        md: '496px'
                    },
                    rounded: "3xl",
                    overflow: "hidden",
                    border: "1px",
                    borderColor: project.color,
                    mb: 6,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                        src: project.thumbnail,
                        alt: "".concat(project.name, " thumbnail"),
                        layout: "fill",
                        objectFit: "cover",
                        objectPosition: "center center"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* LinkOverlay */.AB, {
                    href: project.url,
                    isExternal: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                        fontSize: {
                            base: 'xl'
                        },
                        px: 2,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                as: "strong",
                                color: project.color,
                                children: project.name
                            }),
                            ' ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                as: "span",
                                fontWeight: {
                                    base: 'normal',
                                    md: 'semibold'
                                },
                                children: project.description
                            })
                        ]
                    })
                })
            ]
        }, project.id);
    });
    var ref1;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* Section */.$0, {
                id: "featured-projects",
                maxW: "container.2xl",
                overflow: "visible",
                display: {
                    base: 'none',
                    lg: 'block'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                    bgColor: (ref1 = activeShowcase === null || activeShowcase === void 0 ? void 0 : activeShowcase.bgColor) !== null && ref1 !== void 0 ? ref1 : '#F3FFF8',
                    rounded: "3xl",
                    px: "4",
                    py: "12",
                    position: "relative",
                    transitionProperty: "background-color",
                    transitionDuration: ".3s",
                    children: [
                        activeShowcase && /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_close_button_esm/* CloseButton */.P, {
                            zIndex: 1,
                            position: "absolute",
                            size: "lg",
                            top: 6,
                            right: 6,
                            onClick: function() {
                                return clearActiveShowcase();
                            },
                            color: activeShowcase.descriptionColor
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* MotionFlex */.HZ, {
                            w: "full",
                            direction: "column",
                            variants: container,
                            initial: "initial",
                            whileInView: "animate",
                            viewport: {
                                amount: 0.5,
                                once: true
                            },
                            onViewportEnter: function() {
                                return setIsInView(true);
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                    exitBeforeEnter: true,
                                    children: isInView && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                        children: activeShowcase ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(components/* MotionText */.Tf, {
                                            color: activeShowcase.color,
                                            fontSize: "2xl",
                                            minH: "45px",
                                            variants: text,
                                            initial: isInView ? 'initial' : undefined,
                                            animate: isInView ? 'animate' : undefined,
                                            exit: isInView ? 'initial' : undefined,
                                            // @ts-ignore chakra overrides transition type
                                            transition: transition,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    as: "strong",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Link */.rU, {
                                                        href: activeShowcase.url,
                                                        isExternal: true,
                                                        children: activeShowcase.name
                                                    })
                                                }),
                                                ' ',
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                                    as: "strong",
                                                    color: activeShowcase.descriptionColor,
                                                    children: activeShowcase.description
                                                })
                                            ]
                                        }, activeShowcase.name) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionText */.Tf, {
                                            color: "darkgreen",
                                            fontSize: "3xl",
                                            variants: defaultText,
                                            initial: "initial",
                                            animate: "animate",
                                            exit: "initial",
                                            fontWeight: "bold",
                                            // @ts-ignore chakra overrides transition type
                                            transition: transition,
                                            children: "Click and hold a project"
                                        }, "default-text")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionFlex */.HZ, {
                                    flex: 1,
                                    justify: "center",
                                    align: "center",
                                    // overflow="hidden"
                                    viewport: {
                                        amount: 0.5
                                    },
                                    onViewportLeave: function() {
                                        activeShowcase && clearActiveShowcase();
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimatePresence/* AnimatePresence */.M, {
                                        exitBeforeEnter: true,
                                        children: !isInView ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionFlex */.HZ, {
                                            bgColor: "black",
                                            w: "330px",
                                            h: "180px",
                                            mt: "92px",
                                            rounded: "xl",
                                            justify: "center",
                                            align: "center",
                                            variants: initialBox,
                                            exit: "exit",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                src: Logo_01/* default */.Z,
                                                width: "80px",
                                                height: "100%",
                                                alt: "chacra-icon"
                                            })
                                        }, "initial-box") : activeShowcase ? /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Showcase */.$m, {
                                            children: activeShowcase.galleries.map(function(gallery) {
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* ActiveShowcaseItem */.oW, _objectSpread({
                                                    borderColor: activeShowcase.color
                                                }, gallery), "gallery-".concat(gallery.id));
                                            })
                                        }, "active-showcase") : /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Showcase */.$m, {
                                            children: projectItems
                                        }, "showcase")
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionContainer */.NM, {
                                    maxW: "container.xl",
                                    fontWeight: "bold",
                                    color: "gray.500",
                                    fontSize: "lg",
                                    mt: 32,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FeaturedProjects_FeaturedProjectsTags, {})
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* Section */.$0, {
                id: "featured-projects-mobile",
                display: {
                    base: 'block',
                    lg: 'none'
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* VStack */.gC, {
                    spacing: 16,
                    children: projectItemsMobile
                })
            })
        ]
    });
};
/* harmony default export */ var FeaturedProjects = (FeatureProjects);


/***/ }),

/***/ 4033:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ HeroBanner_HeroBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
// EXTERNAL MODULE: ./src/assets/images/Logo-01.svg
var Logo_01 = __webpack_require__(3830);
// EXTERNAL MODULE: ./src/components/index.ts + 50 modules
var components = __webpack_require__(2836);
;// CONCATENATED MODULE: ./src/page-components/home/HeroBanner/HeroBannerLogo.tsx





var HeroBannerLogo = function(_props) {
    var variants = {
        slideUp: {
            y: '-10%',
            opacity: 0
        },
        slideDown: {
            y: '40%',
            opacity: 1,
            transition: {
                duration: 0.7,
                delay: 0.5,
                damping: 14,
                stiffness: 100,
                type: 'spring'
            }
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
        position: "absolute",
        top: "-40",
        left: "0",
        w: "full",
        h: "130vh",
        py: {
            base: '4',
            md: '10'
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
            h: "full",
            w: "full",
            opacity: "0.27",
            maxW: "720px",
            m: "auto",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionBox */.uH, {
                h: {
                    base: 'full',
                    xs: 'full',
                    md: 'full',
                    lg: 'full',
                    xl: 'full'
                },
                w: "full",
                position: "relative",
                variants: variants,
                initial: "slideUp",
                animate: "slideDown",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                    alt: "chacra-logo",
                    src: Logo_01/* default */.Z,
                    layout: "fill",
                    objectFit: "contain",
                    draggable: false,
                    priority: true
                })
            })
        })
    });
};
/* harmony default export */ var HeroBanner_HeroBannerLogo = (HeroBannerLogo);

// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
// EXTERNAL MODULE: ./node_modules/typewriter-effect/dist/react.js
var react = __webpack_require__(5459);
var react_default = /*#__PURE__*/__webpack_require__.n(react);
;// CONCATENATED MODULE: ./src/page-components/home/HeroBanner/HeroBanner.tsx






var HeroBanner = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* Section */.$0, {
        display: "flex",
        position: "relative",
        minHeight: "100vh",
        my: 0,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeroBanner_HeroBannerLogo, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Container */.W2, {
                maxWidth: "container.xl",
                m: "auto",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        as: "h1",
                        size: "3xl",
                        fontSize: {
                            base: '2xl',
                            xs: '3xl',
                            md: '4xl',
                            lg: '6xl'
                        },
                        mt: {
                            base: '6',
                            lg: '12'
                        },
                        lineHeight: "short",
                        children: "American Engineering"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        as: "h1",
                        fontSize: {
                            base: '2xl',
                            xs: '3xl',
                            md: '4xl',
                            lg: '6xl'
                        },
                        mb: {
                            base: '4',
                            lg: '8'
                        },
                        lineHeight: "short",
                        children: "Affordable Rates"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        as: "h2",
                        fontSize: {
                            base: 'lg',
                            xs: 'xl',
                            md: '2xl',
                            lg: '3xl'
                        },
                        fontWeight: "normal",
                        children: "We deliver digital success"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Heading */.X6, {
                        as: "h2",
                        fontSize: {
                            base: 'lg',
                            xs: 'xl',
                            md: '2xl',
                            lg: '3xl'
                        },
                        fontWeight: "normal",
                        sx: {
                            div: {
                                display: 'inline-block'
                            }
                        },
                        children: [
                            "with\xa0",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((react_default()), {
                                options: {
                                    strings: [
                                        'Integrity.',
                                        'Quality.',
                                        'Trust.'
                                    ],
                                    autoStart: true,
                                    loop: true
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "/contact-us",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                            id: "quote-cta-btn",
                            as: "a",
                            size: "lg",
                            fontSize: "xl",
                            mt: "6",
                            children: "Get a Free Quote"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var HeroBanner_HeroBanner = (HeroBanner);


/***/ }),

/***/ 7209:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8527);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(6723);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1664);
/* harmony import */ var react_player__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2004);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(6546);
/* harmony import */ var gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1025);
/* harmony import */ var gsap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(6038);
/* harmony import */ var _hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4045);
/* harmony import */ var _hooks_useSelector__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3421);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var OurServices = function() {
    var ref = _slicedToArray((0,_hooks_useSelector__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(null), 2), q = ref[0], ref1 = ref[1];
    (0,_hooks_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(function() {
        gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__.ScrollTrigger.matchMedia({
            '(min-width: 48em)': function() {
                gsap__WEBPACK_IMPORTED_MODULE_7__/* ["default"].to */ .ZP.to(q('#our-services-container'), {
                    xPercent: -50,
                    scrollTrigger: {
                        id: 'our-services',
                        trigger: ref1.current,
                        pin: true,
                        start: 'top top',
                        end: function() {
                            return "+=3000";
                        },
                        scrub: 1
                    }
                });
            }
        });
        return function() {
            gsap_dist_ScrollTrigger__WEBPACK_IMPORTED_MODULE_6__.ScrollTrigger.clearMatchMedia();
        };
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$0, {
                ref: ref1,
                display: {
                    base: 'none',
                    md: 'block'
                },
                maxW: "full",
                p: 0,
                overflow: "hidden",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                    id: "our-services-container",
                    h: "100vh",
                    w: "200%",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W2, {
                            flex: 1,
                            maxW: "1680px",
                            h: "full",
                            px: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                w: "full",
                                h: "full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                        flex: "30%",
                                        justify: "center",
                                        direction: "column",
                                        textAlign: "left",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
                                                size: "2xl",
                                                mb: "6",
                                                color: "darkgreen",
                                                children: [
                                                    "Custom Built ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " Software"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                fontSize: "2xl",
                                                mb: "2",
                                                children: [
                                                    "Websites and web apps ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " that make you stand out."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .UnorderedList */ .QI, {
                                                fontSize: "2xl",
                                                sx: {
                                                    'li::before': {
                                                        content: '"- "',
                                                        marginLeft: '-24px'
                                                    }
                                                },
                                                listStyleType: "none",
                                                mb: "6",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Enhanced SEO"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Modern animations"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Performance analytics"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Lightweight & responsive"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                href: "/contact-us",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                                    id: "software-start-cta-btn-web",
                                                    as: "a",
                                                    size: "lg",
                                                    children: "Start Now"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        flex: "70%",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            url: "https://res.cloudinary.com/hfq3eckim/video/upload/v1643018581/csv2/Software_Dev_Render_Green_ver_nuloyx.webm",
                                            playing: true,
                                            loop: true,
                                            muted: true,
                                            height: "100vh",
                                            width: "100%"
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Container */ .W2, {
                            flex: 1,
                            maxW: "1680px",
                            h: "full",
                            px: 12,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                w: "full",
                                h: "full",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                        flex: "30%",
                                        justify: "center",
                                        direction: "column",
                                        textAlign: "left",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
                                                size: "2xl",
                                                mb: "6",
                                                color: "darkgreen",
                                                children: [
                                                    "Design & ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    "Marketing"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                fontSize: "2xl",
                                                mb: "2",
                                                children: [
                                                    "Branding and digital marketing ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                    " that amplify your message."
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .UnorderedList */ .QI, {
                                                fontSize: "2xl",
                                                sx: {
                                                    'li::before': {
                                                        content: '"- "',
                                                        marginLeft: '-24px'
                                                    }
                                                },
                                                listStyleType: "none",
                                                mb: "6",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Business branding"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "UI/UX design"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Video & animations"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                                        children: "Digital marketing"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                                href: "/contact-us",
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                                    id: "marketing-start-cta-btn-web",
                                                    as: "a",
                                                    size: "lg",
                                                    children: "Start Now"
                                                })
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        flex: "70%",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                            url: "https://res.cloudinary.com/hfq3eckim/video/upload/v1643018582/csv2/Marketing_Render_green_ver_dmmyth.webm",
                                            playing: true,
                                            loop: true,
                                            muted: true,
                                            height: "100vh",
                                            width: "100%"
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_3__/* .Section */ .$0, {
                display: {
                    md: 'none'
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .VStack */ .gC, {
                    spacing: {
                        base: 20,
                        md: 40
                    },
                    fontSize: "xl",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    url: [
                                        {
                                            src: 'https://res.cloudinary.com/hfq3eckim/video/upload/v1643018581/csv2/Software_Dev_Render_Green_ver_nuloyx.webm',
                                            type: 'video/webm'
                                        },
                                        {
                                            src: 'https://res.cloudinary.com/hfq3eckim/video/upload/v1644224488/csv2/Software_Dev_Render_u8vu4r.mp4',
                                            type: 'video/mp4'
                                        }, 
                                    ],
                                    playing: true,
                                    playsinline: true,
                                    loop: true,
                                    muted: true,
                                    height: "100%",
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
                                    size: "xl",
                                    mb: "6",
                                    color: "darkgreen",
                                    mt: 12,
                                    children: [
                                        "Custom Built ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        " Software"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                    mb: "6",
                                    children: [
                                        "Websites and web apps ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        " that make you stand out."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .UnorderedList */ .QI, {
                                    sx: {
                                        'li::before': {
                                            content: '"- "',
                                            marginLeft: '-24px'
                                        }
                                    },
                                    listStyleType: "none",
                                    mb: "6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Enhanced SEO"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Modern animations"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Performance analytics"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Lightweight & responsive"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/contact-us",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                        id: "software-start-cta-btn-mob",
                                        as: "a",
                                        size: "lg",
                                        isFullWidth: true,
                                        maxW: "300px",
                                        mt: 6,
                                        children: "Start Now"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_player__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                    url: [
                                        {
                                            src: 'https://res.cloudinary.com/hfq3eckim/video/upload/v1643018582/csv2/Marketing_Render_green_ver_dmmyth.webm',
                                            type: 'video/webm'
                                        },
                                        {
                                            src: 'https://res.cloudinary.com/hfq3eckim/video/upload/v1644224495/csv2/Marketing_Render_gkztji.mp4',
                                            type: 'video/mp4'
                                        }, 
                                    ],
                                    playing: true,
                                    playsinline: true,
                                    loop: true,
                                    muted: true,
                                    height: "100%",
                                    width: "100%"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
                                    size: "xl",
                                    mb: "6",
                                    color: "darkgreen",
                                    mt: 12,
                                    children: [
                                        "Design & ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        "Marketing"
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                    mb: "6",
                                    children: [
                                        "Branding and digital marketing ",
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                        " that amplify your message."
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .UnorderedList */ .QI, {
                                    sx: {
                                        'li::before': {
                                            content: '"- "',
                                            marginLeft: '-24px'
                                        }
                                    },
                                    listStyleType: "none",
                                    mb: "6",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Business branding"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "UI/UX design"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Video & animations"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .ListItem */ .HC, {
                                            children: "Digital marketing"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_link__WEBPACK_IMPORTED_MODULE_1__["default"], {
                                    href: "/contact-us",
                                    passHref: true,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .zx, {
                                        id: "marketing-start-cta-btn-mob",
                                        as: "a",
                                        size: "lg",
                                        isFullWidth: true,
                                        maxW: "300px",
                                        mt: 6,
                                        children: "Start Now"
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (OurServices);


/***/ }),

/***/ 6445:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OurValues_OurValues; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(949);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
;// CONCATENATED MODULE: ./src/page-components/home/OurValues/OurValuesInfoItem.tsx


var OurValuesInfoItem = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
        w: {
            base: 'full',
            md: '360px'
        },
        color: "white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                fontSize: {
                    base: 'xl',
                    lg: '3xl'
                },
                mb: "4",
                children: props.heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                maxW: "280px",
                mx: "auto",
                fontFamily: "Montserrat",
                fontSize: {
                    base: 'lg',
                    lg: 'xl'
                },
                children: props.description
            })
        ]
    });
};
/* harmony default export */ var OurValues_OurValuesInfoItem = (OurValuesInfoItem);

// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
// EXTERNAL MODULE: ./node_modules/gsap/index.js + 2 modules
var gsap = __webpack_require__(6038);
// EXTERNAL MODULE: ./src/hooks/useIsomorphicLayoutEffect.ts
var useIsomorphicLayoutEffect = __webpack_require__(4045);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/hooks/useSelector.tsx
var useSelector = __webpack_require__(3421);
;// CONCATENATED MODULE: ./src/page-components/home/OurValues/OurValues.tsx
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}








var OurValues = function() {
    var setColorMode = (0,chakra_ui_color_mode_esm/* useColorMode */.If)().setColorMode;
    var ref2 = _slicedToArray((0,useSelector/* default */.Z)(null), 2), q = ref2[0], ref1 = ref2[1];
    var bgPatternTl = (0,react.useRef)();
    var bgColorAndHeadingTl = (0,react.useRef)();
    var itemsTl = (0,react.useRef)();
    // bg pattern animation
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        bgPatternTl.current = gsap/* default.timeline */.ZP.timeline({
            repeat: -1
        }).to(ref1.current, {
            backgroundPosition: '250px -250px',
            duration: 8,
            ease: 'none'
        });
        return function() {
            var ref;
            (ref = bgPatternTl.current) === null || ref === void 0 ? void 0 : ref.kill();
        };
    }, []);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        var clipPath = gsap/* default.to */.ZP.to(ref1.current, {
            clipPath: 'inset(20% 20% 20%)',
            scrollTrigger: {
                markers: false,
                trigger: q('#block-container'),
                scrub: 1,
                start: function() {
                    return '+=2000 top-=20%';
                },
                end: function() {
                    return '+=80%';
                }
            }
        });
        return function() {
            var ref;
            clipPath.kill();
            (ref = clipPath.scrollTrigger) === null || ref === void 0 ? void 0 : ref.kill();
        };
    }, []);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        itemsTl.current = gsap/* default.timeline */.ZP.timeline({
            scrollTrigger: {
                id: 'our-values-section',
                pin: true,
                trigger: ref1.current,
                scrub: true,
                start: function() {
                    return 'top';
                },
                end: function() {
                    return '+=2000';
                },
                onLeave: function() {
                    setColorMode('light');
                },
                markers: false
            }
        }).fromTo(q('.info-item'), {
            opacity: 0,
            yPercent: 100
        }, {
            opacity: 1,
            yPercent: 0,
            stagger: 0.3
        });
        return function() {
            var ref, ref3, ref4;
            (ref = itemsTl.current) === null || ref === void 0 ? void 0 : ref.kill();
            (ref3 = itemsTl.current) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.scrollTrigger) === null || ref4 === void 0 ? void 0 : ref4.kill();
        };
    }, []);
    (0,useIsomorphicLayoutEffect/* default */.Z)(function() {
        bgColorAndHeadingTl.current = gsap/* default.timeline */.ZP.timeline({
            scrollTrigger: {
                id: 'bg-color-and-heading',
                trigger: q('#our-values-heading'),
                toggleActions: 'play none none reverse',
                start: function() {
                    return 'center center';
                },
                end: function() {
                    return 'center center';
                },
                onEnter: function() {
                    setColorMode('dark');
                },
                onEnterBack: function() {
                    setColorMode('light');
                },
                markers: false
            }
        }).fromTo(q('#our-values-heading'), {
            opacity: 0
        }, {
            opacity: 1,
            duration: 0.2,
            ease: 'none'
        }).to(ref1.current, {
            backgroundColor: '#000000',
            duration: 0.2,
            ease: 'none'
        });
        return function() {
            var ref, ref5, ref6;
            (ref = bgColorAndHeadingTl.current) === null || ref === void 0 ? void 0 : ref.kill();
            (ref5 = bgColorAndHeadingTl.current) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.scrollTrigger) === null || ref6 === void 0 ? void 0 : ref6.kill();
        };
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* Section */.$0, {
        ref: ref1,
        h: "100vh",
        minW: "full",
        p: 0,
        m: 0,
        bgImage: "/bg-pattern-1.png",
        bgRepeat: "repeat",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
            id: "block-container",
            h: "100vh",
            w: "full",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                h: "full",
                fontFamily: "Bebas Neue",
                fontWeight: "normal",
                align: "center",
                direction: "column",
                minH: "inherit",
                w: "full",
                color: "white",
                overflow: "hidden",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Heading */.X6, {
                        id: "our-values-heading",
                        size: "3xl",
                        mt: 14,
                        mb: 6,
                        children: "Our Values"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                        className: "our-values",
                        flex: 1,
                        justify: "center",
                        align: "center",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Wrap */.Eq, {
                            spacing: 10,
                            align: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* WrapItem */.Uc, {
                                    className: "info-item",
                                    w: {
                                        base: 'full',
                                        md: 'inherit'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurValues_OurValuesInfoItem, {
                                        heading: "Client Driven",
                                        description: "We bring tremendous energy into every project we start."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* WrapItem */.Uc, {
                                    className: "info-item",
                                    w: {
                                        base: 'full',
                                        md: 'inherit'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurValues_OurValuesInfoItem, {
                                        heading: "Quality Focused",
                                        description: "We set clear expectations and deliver them as promised."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* WrapItem */.Uc, {
                                    className: "info-item",
                                    w: {
                                        base: 'full',
                                        md: 'inherit'
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurValues_OurValuesInfoItem, {
                                        heading: "Transparency Oriented",
                                        description: "We are highly responsive and maintain open communication."
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var OurValues_OurValues = (OurValues);


/***/ }),

/***/ 3521:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Testimonials_Testimonials; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(1082);
// EXTERNAL MODULE: ./node_modules/swiper/modules/autoplay/autoplay.min.css
var autoplay_min = __webpack_require__(3731);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/chakra-ui-button.esm.js + 1 modules
var chakra_ui_button_esm = __webpack_require__(6723);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/swiper/react/swiper-react.js + 13 modules
var swiper_react = __webpack_require__(8352);
// EXTERNAL MODULE: ./node_modules/swiper/swiper.esm.js + 90 modules
var swiper_esm = __webpack_require__(1911);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
// EXTERNAL MODULE: ./node_modules/react-lottie-player/dist/LottiePlayer.modern.js
var LottiePlayer_modern = __webpack_require__(9185);
// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
// EXTERNAL MODULE: ./src/components/index.ts + 50 modules
var components = __webpack_require__(2836);
;// CONCATENATED MODULE: ./src/assets/lotties/chacra-testimonial.json
var chacra_testimonial_namespaceObject = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE 1.0.0","a":"","k":"","d":"","tc":"#FFFFFF"},"fr":29.9700012207031,"ip":0,"op":80.0000032584668,"w":1000,"h":1000,"nm":"Comp 1","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Layer 1 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[507.96,620.575,0],"ix":2},"a":{"a":0,"k":[1265.85,1308.25,0],"ix":1},"s":{"a":0,"k":[26.962,26.962,100],"ix":6}},"ao":0,"ef":[{"ty":21,"nm":"Fill","np":9,"mn":"ADBE Fill","ix":1,"en":1,"ef":[{"ty":10,"nm":"Fill Mask","mn":"ADBE Fill-0001","ix":1,"v":{"a":0,"k":0,"ix":1}},{"ty":7,"nm":"All Masks","mn":"ADBE Fill-0007","ix":2,"v":{"a":0,"k":0,"ix":2}},{"ty":2,"nm":"Color","mn":"ADBE Fill-0002","ix":3,"v":{"a":0,"k":[0.752941191196,0.901960790157,0.815686285496,1],"ix":3}},{"ty":7,"nm":"Invert","mn":"ADBE Fill-0006","ix":4,"v":{"a":0,"k":0,"ix":4}},{"ty":0,"nm":"Horizontal Feather","mn":"ADBE Fill-0003","ix":5,"v":{"a":0,"k":0,"ix":5}},{"ty":0,"nm":"Vertical Feather","mn":"ADBE Fill-0004","ix":6,"v":{"a":0,"k":0,"ix":6}},{"ty":0,"nm":"Opacity","mn":"ADBE Fill-0005","ix":7,"v":{"a":0,"k":1,"ix":7}}]}],"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[2.67,-65.6],[-0.431,-1.171],[12.6,20.47],[5.2,0],[-86.76,-53.83],[-44.8,-28.4],[0,0],[6.93,-9.6],[0,0],[40,16.53],[0,-3.73],[-35.2,-20.26],[0,0],[-4.01,-35.491],[0.27,-52.4],[-2.74,-29.22],[4.31,-13.33],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[40.31,-77.97],[11.8,-3.37],[16.698,16.118],[19.555,-16.888],[92.8,-91.2],[31.2,-16],[60.8,-37.6],[0,0],[0,0],[0,0],[57.6,19.2],[5.788,-12.833],[3.455,0.692],[19.2,14.4],[4.239,-13.76],[7.454,2.236],[30.4,25.6],[17.6,9.6],[7.2,-31.2],[7.2,3.6],[3.6,3.6],[16.8,-6],[18,4.8],[18,20.4],[35.2,20.8],[31.14,56.979],[11.4,1.2],[32.84,20.06],[-24.31,71.76],[-2.56,7.25],[0,0],[-0.47,48.55],[-3.15,21.81],[0,0],[17.82,2.83],[53.87,60.13],[7.81,45.8],[0,0],[-38.4,14.401],[0,0],[36.85,-12.119],[4.19,0],[0,0],[-22.841,9.3],[-56.8,63.07],[-8.25,36.02],[7.47,-1.6],[10.67,-43.2],[0,0],[8.26,66.13],[5.87,-1.601],[0,-40],[0,0],[8.54,11.2],[5.33,-1.6],[8,-72.53],[0,0],[5.33,39.469],[5.87,-1.07],[21.86,-75.74],[1.429,-0.42],[-17.13,17.81],[7.07,-0.53],[32,-35.2],[0,0],[-15.47,36.8],[8,-0.54],[126.01,8.09],[6.4,1.07],[-6.929,-33.599],[0,0],[27.2,25.06],[5.87,1.07],[-8.53,-17.6],[-0.59,-0.79],[22.75,26.99],[0,0],[-16,19.6],[5.2,0.4],[16.4,-18],[0,0],[-8.4,30.8],[3.87,4.271],[20.26,-64.54],[0,0],[14,47.999],[0,0],[5.601,-17.2],[0,0],[-1.07,28.8],[7.47,0]],"o":[[-2.64,65.11],[-0.51,-0.27],[-12.8,-20.8],[-5.2,0],[66.4,41.2],[44.8,28.4],[0,0],[-6.93,9.601],[0,0],[-40,-16.529],[0,3.74],[35.2,20.27],[0,0],[4.18,36.909],[-0.15,29.93],[4.189,44.66],[-36.05,111.571],[0,0],[0,0],[0,0],[0,0],[0,0],[-21.28,26.81],[-47.14,91.19],[-9.956,2.845],[-20.873,-20.149],[-35.2,30.4],[-92.8,91.2],[-193.17,99.06],[-9.74,6.02],[0,0],[0,0],[0,0],[-32.712,-10.903],[-4.405,9.764],[-8,-1.6],[-10.255,-7.69],[-3.697,12.003],[-16.001,-4.8],[-30.4,-25.6],[-17.6,-9.6],[-7.2,31.2],[-7.2,-3.599],[-3.6,-3.599],[-16.8,6],[-18,-4.8],[-18,-20.4],[-22,-13],[-18.68,-34.191],[-13.1,-1.38],[0,0],[14.1,-41.63],[6.96,-19.76],[0,0],[0.43,-44.51],[6.59,-45.6],[0,0],[-39.9,-6.35],[-26.16,-29.21],[-8.58,-50.34],[0,0],[38.4,-14.4],[0,0],[-33.54,11.03],[-8.8,0],[0,0],[60.79,-24.76],[26.6,-29.529],[13.75,-60.02],[-7.47,1.6],[-10.67,43.2],[0,0],[-6.17,-49.45],[-5.86,1.6],[0,40.001],[0,0],[-8.53,-11.199],[-5.33,1.6],[-8,72.54],[0,0],[-5.33,-39.461],[-5.86,1.06],[-21.7,75.14],[0.7,-0.74],[17.4,-18.08],[-7.07,0.53],[-32,35.201],[0,0],[15.47,-36.8],[-8,0.53],[-116.27,-7.47],[-6.4,-1.07],[6.941,33.6],[0,0],[-27.2,-25.07],[-5.87,-1.06],[8.42,17.36],[-0.85,-0.48],[-22.94,-27.2],[0,0],[16,-19.6],[-5.2,-0.4],[-16.4,18],[0,0],[8.4,-30.8],[-3.86,-4.26],[-20.27,64.53],[0,0],[-14,-48.001],[0,0],[-5.599,17.2],[0,0],[1.07,-28.8],[-7.46,0]],"v":[[-588.27,-1162.4],[-561.61,-1017.609],[-590.99,-1047.17],[-606.4,-1116],[-553.6,-982.4],[-416.8,-874.4],[-280,-814.129],[-268.8,-788],[-282.67,-786.399],[-340.8,-826.4],[-408,-830.67],[-362.67,-755.47],[-287.2,-751.2],[-259.2,-713.599],[-275.2,-586.4],[-263.2,-501.6],[-265.6,-399.2],[-236.8,-210.4],[-223.47,-149.6],[-186.4,-40],[-166.4,51.2],[-159.18,103.31],[-153.6,143.61],[-244.8,338.4],[-360,512.8],[-401.666,483.408],[-465.6,460],[-547.2,688.8],[-640.8,906.4],[-952.8,1204],[-1057.6,1236],[-1265.6,1308],[1265.6,1308],[1160,1082.4],[1109.429,1097.163],[1100.8,1116],[1020.8,989.6],[1001.985,1009.43],[987.2,1031.2],[870.4,832.8],[779.2,732],[707.6,787.2],[686,846],[676.4,810],[627.2,822],[545.6,914.4],[434,494.4],[364.8,466.4],[268,323.201],[228.8,256.8],[146.78,218.74],[191.2,58.4],[230.4,-28],[207.2,-100.8],[198.4,-193.87],[217.07,-302.67],[151.2,-443.2],[107.73,-474.4],[-44.8,-524.4],[-110.8,-687.6],[-103.6,-743.6],[-28.8,-746.8],[21.07,-838.67],[-45.33,-826.4],[-124,-792.269],[-124.8,-804.53],[-89.2,-825.2],[145.6,-952.27],[213.87,-1062.67],[204.8,-1169.87],[201.6,-1085.6],[177.07,-1041.87],[183.21,-1178.93],[142.93,-1290.399],[162.13,-1193.87],[155.2,-1132.53],[142.93,-1169.87],[110.4,-1193.33],[140.8,-1073.869],[110.4,-986.4],[102.4,-1080.269],[67.73,-1135.73],[79.47,-978.93],[-35.71,-875.74],[4.8,-917.87],[27.6,-985.6],[-31.2,-910],[-96,-861.6],[-60.8,-927.2],[-52.8,-1028.53],[-202.13,-846.13],[-333.87,-1026.4],[-332.271,-939.47],[-298.67,-865.869],[-356.8,-906.93],[-404.8,-987.47],[-397.87,-932.53],[-366.94,-885.08],[-445.33,-943.73],[-469.6,-1024.4],[-434,-1060.8],[-418.8,-1111.6],[-444.8,-1071.6],[-470,-1054.4],[-463.2,-1116.4],[-429.87,-1185.87],[-486.93,-1103.73],[-497.2,-997.6],[-539.6,-1062.799],[-526,-1189.2],[-548.001,-1164.8],[-555.73,-1112.8],[-564.8,-1194.4],[-548.27,-1308]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[6.71,0.14],[0,0],[0,0],[0,0],[-7.15,-38.39],[-1.21,-14.81],[0.17,-27.44]],"o":[[0,0],[0,0],[0,0],[0,0],[4.38,23.57],[2.61,31.72],[-7.21,-2.26]],"v":[[-120.03,127.8],[-135.2,12.8],[-150.4,-160],[-127.47,-161.33],[-118.93,-85.07],[-101.35,-4.51],[-99.13,131.68]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[-11.851,40.45],[-1.62,11.37],[8.94,21.87],[0,0],[-25.51,-27.98],[-1.06,-18.05],[13.55,-47.94],[0.34,0.27],[16.8,7.2],[15.99,-3.8]],"o":[[10.49,-35.77],[2.13,-14.93],[-8.93,-21.86],[0,0],[20.23,22.2],[1.95,33.19],[-0.35,-0.27],[-23.85,-19.211],[-8.25,-3.54],[5.97,-23.85]],"v":[[73.6,45.6],[99.2,-32.8],[75.73,-102.67],[65.6,-135.2],[103.2,-88],[159.2,-18.4],[111.43,194.42],[110.4,193.601],[80,151.2],[44.16,155.2]],"c":true},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":0,"k":{"i":[[7.895,1.149],[12.29,5.01],[-3.88,17.251],[0,0],[0,0],[-4.13,-12.53],[7.25,-37.99],[1.996,0]],"o":[[-13,-1.89],[-0.26,-42.53],[4.8,-21.33],[0,0],[0,0],[3.54,10.72],[-1.919,0.074],[-6.931,0]],"v":[[-20.8,159.2],[-58.79,147.81],[-55.47,-24.8],[-40,-112.27],[-12.27,-70.13],[35.73,-19.47],[7.3,160.71],[1.427,160.823]],"c":true},"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"fl","c":{"a":0,"k":[0.752941236309,0.901960844152,0.819607902976,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1265.85,1308.25],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":86.0000035028518,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Layer 1 Outlines","sr":1,"ks":{"o":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20,"s":[0]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":50,"s":[100]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":65,"s":[100]},{"t":79.000003217736,"s":[0]}],"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[508,621.302,0],"ix":2},"a":{"a":0,"k":[387.6,400.501,0],"ix":1},"s":{"a":0,"k":[88.854,88.495,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[5.112,2.191],[4.865,-1.156],[-3.606,12.308],[-0.493,3.46],[2.72,6.654],[0,0],[-7.762,-8.514],[-0.322,-5.493],[4.123,-14.587],[0.104,0.082]],"o":[[-2.51,-1.077],[1.816,-7.257],[3.192,-10.884],[0.648,-4.543],[-2.718,-6.652],[0,0],[6.156,6.755],[0.594,10.099],[-0.107,-0.082],[-7.257,-5.846]],"v":[[24.343,46.008],[13.438,47.225],[22.396,13.876],[30.185,-9.98],[23.044,-31.24],[19.961,-41.139],[31.402,-26.776],[48.442,-5.598],[33.907,59.159],[33.593,58.91]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ind":1,"ty":"sh","ix":2,"ks":{"a":0,"k":{"i":[[2.206,-11.56],[3.095,0.451],[3.739,1.525],[-1.181,5.249],[0,0],[0,0],[-1.256,-3.813]],"o":[[-2.611,0.1],[-3.955,-0.575],[-0.079,-12.941],[1.46,-6.49],[0,0],[0,0],[1.078,3.262]],"v":[[2.222,48.902],[-6.329,48.442],[-17.888,44.976],[-16.878,-7.546],[-12.171,-34.161],[-3.733,-21.339],[10.872,-5.924]],"c":true},"ix":2},"nm":"Path 2","mn":"ADBE Vector Shape - Group","hd":false},{"ind":2,"ty":"sh","ix":3,"ks":{"a":0,"k":{"i":[[0.052,-8.349],[2.042,0.042],[0,0],[0,0],[0,0],[-2.176,-11.681],[-0.368,-4.506]],"o":[[-2.194,-0.687],[0,0],[0,0],[0,0],[0,0],[1.333,7.172],[0.795,9.652]],"v":[[-30.163,40.068],[-36.523,38.888],[-41.139,3.895],[-45.764,-48.685],[-38.786,-49.089],[-36.188,-25.885],[-30.839,-1.372]],"c":true},"ix":2},"nm":"Path 3","mn":"ADBE Vector Shape - Group","hd":false},{"ind":3,"ty":"sh","ix":4,"ks":{"a":0,"k":{"i":[[17.527,5.842],[2.434,0.487],[5.842,4.381],[4.869,1.46],[9.25,7.79],[5.356,2.921],[2.191,-9.494],[2.191,1.096],[1.096,1.096],[5.112,-1.826],[5.477,1.461],[5.477,6.207],[10.71,6.329],[9.476,17.338],[3.469,0.365],[9.993,6.104],[-7.397,21.835],[-0.779,2.206],[0,0],[-0.143,14.773],[-0.958,6.637],[0,0],[5.422,0.861],[16.391,18.296],[2.376,13.936],[0,0],[-11.684,4.382],[0,0],[11.213,-3.688],[1.275,0],[0,0],[-6.949,2.83],[-17.283,19.191],[-2.51,10.96],[2.273,-0.486],[3.246,-13.145],[0,0],[2.513,20.122],[1.787,-0.487],[0,-12.172],[0,0],[2.599,3.408],[1.622,-0.487],[2.435,-22.07],[0,0],[1.622,12.01],[1.787,-0.326],[6.651,-23.046],[0.436,-0.128],[-5.212,5.419],[2.151,-0.162],[9.737,-10.71],[0,0],[-4.707,11.197],[2.435,-0.165],[38.342,2.462],[1.947,0.325],[-2.108,-10.224],[0,0],[8.277,7.626],[1.786,0.325],[-2.596,-5.356],[-0.18,-0.24],[6.923,8.212],[0,0],[-4.869,5.963],[1.582,0.122],[4.99,-5.477],[0,0],[-2.556,9.372],[1.178,1.299],[6.165,-19.639],[0,0],[4.259,14.606],[0,0],[1.704,-5.233],[0,0],[-0.326,8.764],[2.273,0],[0.813,-19.961],[-0.131,-0.357],[3.834,6.229],[1.583,0],[-26.4,-16.379],[-13.631,-8.642],[0,0],[2.109,-2.921],[0,0],[12.171,5.03],[0,-1.135],[-10.71,-6.165],[0,0],[-1.22,-10.799],[0.082,-15.944],[-0.833,-8.891],[1.311,-4.056],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[12.266,-23.725],[3.59,-1.026],[10.711,-9.25],[28.237,-27.75],[9.494,-4.868],[18.5,-11.441],[0,0],[0,0],[0,0]],"o":[[-17.526,-5.842],[-2.435,-0.487],[-5.842,-4.382],[-4.868,-1.461],[-9.25,-7.79],[-5.355,-2.921],[-2.191,9.493],[-2.191,-1.095],[-1.095,-1.095],[-5.112,1.825],[-5.477,-1.46],[-5.477,-6.208],[-6.695,-3.956],[-5.684,-10.404],[-3.986,-0.42],[0,0],[4.291,-12.668],[2.118,-6.013],[0,0],[0.131,-13.543],[2.005,-13.875],[0,0],[-12.141,-1.932],[-7.96,-8.888],[-2.611,-15.318],[0,0],[11.685,-4.381],[0,0],[-10.205,3.357],[-2.677,0],[0,0],[18.498,-7.533],[8.094,-8.985],[4.184,-18.263],[-2.273,0.487],[-3.247,13.145],[0,0],[-1.877,-15.047],[-1.783,0.487],[0,12.171],[0,0],[-2.595,-3.408],[-1.622,0.487],[-2.434,22.072],[0,0],[-1.622,-12.007],[-1.783,0.322],[-6.603,22.864],[0.213,-0.225],[5.294,-5.502],[-2.152,0.161],[-9.737,10.711],[0,0],[4.707,-11.198],[-2.434,0.161],[-35.379,-2.273],[-1.948,-0.326],[2.112,10.224],[0,0],[-8.276,-7.628],[-1.786,-0.323],[2.562,5.282],[-0.259,-0.146],[-6.98,-8.277],[0,0],[4.868,-5.964],[-1.582,-0.122],[-4.991,5.477],[0,0],[2.556,-9.371],[-1.174,-1.296],[-6.168,19.635],[0,0],[-4.26,-14.606],[0,0],[-1.704,5.234],[0,0],[0.325,-8.763],[-2.27,0],[-0.803,19.812],[-0.155,-0.083],[-3.894,-6.329],[-1.582,0],[20.204,12.537],[13.632,8.641],[0,0],[-2.108,2.921],[0,0],[-12.171,-5.029],[0,1.138],[10.711,6.168],[0,0],[1.272,11.232],[-0.046,9.107],[1.275,13.59],[-10.969,33.949],[0,0],[0,0],[0,0],[0,0],[0,0],[-6.476,8.157],[-14.344,27.747],[-6.816,1.947],[-10.71,9.251],[-28.237,27.751],[-58.778,30.142],[-2.964,1.831],[0,0],[0,0],[0,0]],"v":[[352.968,329.355],[334.955,339.579],[310.612,301.119],[300.388,313.776],[264.848,253.406],[237.097,222.734],[215.311,239.531],[208.738,257.422],[205.817,246.469],[190.846,250.12],[166.017,278.235],[132.059,150.438],[111.003,141.917],[81.548,98.345],[69.62,78.14],[44.663,66.558],[58.179,17.771],[70.107,-8.519],[63.048,-30.671],[60.37,-58.991],[66.051,-92.097],[46.008,-134.858],[32.781,-144.351],[-13.631,-159.566],[-33.714,-209.224],[-31.523,-226.264],[-8.763,-227.238],[6.412,-255.192],[-13.793,-251.459],[-37.731,-241.073],[-37.974,-244.804],[-27.142,-251.094],[44.304,-289.759],[65.077,-323.351],[62.317,-355.971],[61.344,-330.329],[53.88,-317.022],[55.748,-358.727],[43.491,-392.646],[49.334,-363.273],[47.225,-344.609],[43.491,-355.971],[33.593,-363.109],[42.843,-326.759],[33.593,-300.144],[31.159,-328.707],[20.609,-345.582],[24.182,-297.871],[-10.866,-266.472],[1.461,-279.291],[8.399,-299.9],[-9.493,-276.897],[-29.211,-262.169],[-18.5,-282.13],[-16.066,-312.963],[-61.504,-257.462],[-101.59,-312.315],[-101.104,-285.864],[-90.88,-263.469],[-108.568,-275.963],[-123.173,-300.469],[-121.064,-283.752],[-111.653,-269.314],[-135.506,-287.16],[-142.891,-311.707],[-132.058,-322.782],[-127.433,-338.24],[-135.344,-326.069],[-143.012,-320.835],[-140.943,-339.701],[-130.802,-360.839],[-148.164,-335.845],[-151.289,-303.552],[-164.19,-323.391],[-160.052,-361.852],[-166.746,-354.428],[-169.099,-338.605],[-171.858,-363.435],[-166.829,-398.001],[-179,-353.698],[-170.888,-309.64],[-179.828,-318.635],[-184.517,-339.579],[-168.45,-298.927],[-126.825,-266.064],[-85.199,-247.725],[-81.791,-239.774],[-86.011,-239.287],[-103.699,-251.459],[-124.147,-252.758],[-110.354,-229.876],[-87.39,-228.577],[-78.87,-217.136],[-83.738,-178.432],[-80.087,-152.628],[-80.817,-121.469],[-72.054,-64.021],[-67.998,-45.52],[-56.718,-12.171],[-50.632,15.58],[-48.435,31.436],[-46.737,43.699],[-74.488,102.969],[-109.541,156.036],[-141.674,139.969],[-166.503,209.589],[-194.984,275.802],[-289.92,366.357],[-321.809,376.094],[-370.188,392.352],[386.225,392.351]],"c":true},"ix":2},"nm":"Path 4","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"mm","mm":1,"nm":"Merge Paths 1","mn":"ADBE Vector Filter - Merge","hd":false},{"ty":"st","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":10,"ix":5},"lc":1,"lj":1,"ml":10,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[387.6,400.501],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":6,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":80.0000032584668,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Layer 2 Outlines 4","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[71]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":8,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":20,"s":[0]},{"t":30.0000012219251,"s":[99]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":20,"s":[136,318,0],"to":[59.333,34,0],"ti":[-59.333,-34,0]},{"t":30.0000012219251,"s":[492,522,0]}],"ix":2},"a":{"a":0,"k":[1098.724,1043.8,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":8,"s":[4.663,4.663,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20,"s":[4.663,4.663,100]},{"t":30.0000012219251,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,634.149],[678.857,1043.55],[499.256,271.433],[1098.474,-247.815],[308.561,-315.591],[0,-1043.55],[-308.561,-315.591],[-1098.474,-247.815],[-499.256,271.433],[-678.857,1043.55]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1098.724,1043.8],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":81.0000032991976,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Layer 2 Outlines 5","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[71]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":8,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":25,"s":[0]},{"t":35.0000014255792,"s":[99]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":25,"s":[277,160,0],"to":[35.917,60.167,0],"ti":[-35.917,-60.167,0]},{"t":35.0000014255792,"s":[492.5,521,0]}],"ix":2},"a":{"a":0,"k":[1098.724,1043.8,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":8,"s":[4.663,4.663,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":25,"s":[4.663,4.663,100]},{"t":35.0000014255792,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,634.149],[678.857,1043.55],[499.256,271.433],[1098.474,-247.815],[308.561,-315.591],[0,-1043.55],[-308.561,-315.591],[-1098.474,-247.815],[-499.256,271.433],[-678.857,1043.55]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1098.724,1043.8],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":86.0000035028518,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Layer 2 Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[71]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":8,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":30,"s":[0]},{"t":40.0000016292334,"s":[99]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":30,"s":[490,68,0],"to":[0,76,0],"ti":[0,-76,0]},{"t":40.0000016292334,"s":[490,524,0]}],"ix":2},"a":{"a":0,"k":[1098.724,1043.8,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":8,"s":[4.663,4.663,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":30,"s":[4.663,4.663,100]},{"t":40.0000016292334,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,634.149],[678.857,1043.55],[499.256,271.433],[1098.474,-247.815],[308.561,-315.591],[0,-1043.55],[-308.561,-315.591],[-1098.474,-247.815],[-499.256,271.433],[-678.857,1043.55]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1098.724,1043.8],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":83.0000033806593,"st":0,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Layer 2 Outlines 3","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[71]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":8,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":35,"s":[0]},{"t":45.0000018328876,"s":[99]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":35,"s":[712,158,0],"to":[-36.667,60.667,0],"ti":[36.667,-60.667,0]},{"t":45.0000018328876,"s":[492,522,0]}],"ix":2},"a":{"a":0,"k":[1098.724,1043.8,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":8,"s":[4.663,4.663,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[4.663,4.663,100]},{"t":45.0000018328876,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,634.149],[678.857,1043.55],[499.256,271.433],[1098.474,-247.815],[308.561,-315.591],[0,-1043.55],[-308.561,-315.591],[-1098.474,-247.815],[-499.256,271.433],[-678.857,1043.55]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1098.724,1043.8],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":83.0000033806593,"st":0,"bm":0},{"ddd":0,"ind":7,"ty":4,"nm":"Layer 2 Outlines 2","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[71]},{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":8,"s":[0]},{"i":{"x":[0.833],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":40,"s":[0]},{"t":50.0000020365418,"s":[99]}],"ix":10},"p":{"a":1,"k":[{"i":{"x":0.667,"y":1},"o":{"x":0.333,"y":0},"t":40,"s":[848,308,0],"to":[-59.333,36.333,0],"ti":[59.333,-36.333,0]},{"t":50.0000020365418,"s":[492,526,0]}],"ix":2},"a":{"a":0,"k":[1098.724,1043.8,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":8,"s":[4.663,4.663,100]},{"i":{"x":[0.833,0.833,0.833],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":40,"s":[4.663,4.663,100]},{"t":50.0000020365418,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"o":[[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0],[0,0]],"v":[[0,634.149],[678.857,1043.55],[499.256,271.433],[1098.474,-247.815],[308.561,-315.591],[0,-1043.55],[-308.561,-315.591],[-1098.474,-247.815],[-499.256,271.433],[-678.857,1043.55]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1098.724,1043.8],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":88.0000035843135,"st":0,"bm":0},{"ddd":0,"ind":8,"ty":0,"nm":"Comp 2","refId":"comp_1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[494,484,0],"ix":2},"a":{"a":0,"k":[500,500,0],"ix":1},"s":{"a":0,"k":[48,48,100],"ix":6}},"ao":0,"w":1000,"h":1000,"ip":0,"op":80.0000032584668,"st":0,"bm":0}]},{"id":"comp_1","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 4","sr":1,"ks":{"o":{"a":0,"k":60,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[484,488,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":20,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":30,"s":[19.608,19.608,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.167,0.167,0.167],"y":[0,0,0]},"t":55,"s":[19.608,19.608,100]},{"t":60.0000024438501,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[776,776],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[0.886274509804,0.65229809331,0.236339853324,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20,22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":80.0000032584668,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 3","sr":1,"ks":{"o":{"a":0,"k":60,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[484,488,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":25,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[42.157,42.157,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":60,"s":[42.157,42.157,100]},{"t":65.0000026475043,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[776,776],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20,22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":80.0000032584668,"st":0,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape Layer 2","sr":1,"ks":{"o":{"a":0,"k":60,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[484,488,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":30,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":40,"s":[69.608,69.608,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":65,"s":[69.608,69.608,100]},{"t":70.0000028511585,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[776,776],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20,22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":80.0000032584668,"st":0,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":60,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[484,488,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":35,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":45,"s":[93.137,93.137,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":70,"s":[93.137,93.137,100]},{"t":75.0000030548126,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[776,776],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20,22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":80.0000032584668,"st":0,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shape Layer 5","sr":1,"ks":{"o":{"a":0,"k":60,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[484,488,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":40,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":50,"s":[115.088,115.088,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":75,"s":[115.088,115.088,100]},{"t":79.000003217736,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"d":1,"ty":"el","s":{"a":0,"k":[776,776],"ix":2},"p":{"a":0,"k":[0,0],"ix":3},"nm":"Ellipse Path 1","mn":"ADBE Vector Shape - Ellipse","hd":false},{"ty":"fl","c":{"a":0,"k":[1,0.752941236309,0.313725490196,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[20,22],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Ellipse 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":80.0000032584668,"st":0,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"Pre-comp 1","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[500,528,0],"ix":2},"a":{"a":0,"k":[500,500,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"w":1000,"h":1000,"ip":0,"op":80.0000032584668,"st":0,"bm":0}],"markers":[]}');
;// CONCATENATED MODULE: ./src/page-components/home/Testimonials/Testimonials.tsx












var Testimonials = function() {
    var ref = (0,react.useState)(true), play = ref[0], setPlay = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(layouts/* Section */.$0, {
        maxW: "container.lg",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* VStack */.gC, {
            w: "full",
            spacing: {
                base: '0',
                lg: '8'
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Flex */.kC, {
                    w: "full",
                    direction: {
                        base: 'column-reverse',
                        md: 'column-reverse',
                        lg: 'row'
                    },
                    bgColor: {
                        base: 'none',
                        md: 'none',
                        lg: '#F3FFF8'
                    },
                    rounded: {
                        base: 'none',
                        md: 'none',
                        lg: '3xl'
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Flex */.kC, {
                            bgColor: {
                                base: 'white',
                                md: 'white',
                                lg: '#F3FFF8'
                            },
                            rounded: {
                                base: '3xl',
                                md: '3xl',
                                lg: '3xl'
                            },
                            justifyContent: "flex-end",
                            flexDir: "column",
                            flex: "40%",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LottiePlayer_modern/* default */.Z, {
                                animationData: chacra_testimonial_namespaceObject,
                                play: play,
                                loop: false,
                                goTo: 0
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                            flex: "60%",
                            overflow: "hidden",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                                w: "full",
                                bgColor: "#F3FFF8",
                                rounded: "3xl",
                                alignSelf: "center",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(swiper_react/* Swiper */.tq, {
                                    modules: [
                                        swiper_esm/* Autoplay */.pt
                                    ],
                                    slidesPerView: 1,
                                    autoplay: {
                                        disableOnInteraction: false,
                                        delay: 3000
                                    },
                                    loop: true,
                                    onSlideChange: function() {
                                        setPlay(false);
                                    },
                                    onSlideChangeTransitionEnd: function() {
                                        setPlay(true);
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Testimonial */.gc, {
                                                title: "Delivered Above Expectations...",
                                                message: "They delivered above expectations in terms of quality and communication.",
                                                name: "Mahmoud Elsoukie",
                                                occupation: "Founder, Construction Company"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Testimonial */.gc, {
                                                title: "Delivered Value for Money...",
                                                message: "They delivered value for money. Their overall business acumen and professionalism are impressive.",
                                                name: "Ahmad Sharaf Aldine",
                                                occupation: "Co-Founder, NUMOO"
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(swiper_react/* SwiperSlide */.o5, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* Testimonial */.gc, {
                                                title: "Ability To Quickly Implement...",
                                                message: "Their understanding of the technology they work on and ability to quickly implement complex solutions were impressive.",
                                                name: "Aileen Miralles",
                                                occupation: "Project Manager, Cosmelt"
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Center */.M5, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: "https://www.clutch.co/profile/chacra-software-solutions-0#reviews",
                        passHref: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_button_esm/* Button */.zx, {
                            id: "clutch-learn-btn",
                            target: "_blank",
                            as: "a",
                            size: "lg",
                            w: {
                                base: '300px',
                                md: '600px',
                                lg: 'auto'
                            },
                            children: "Read Clutch Reviews"
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var Testimonials_Testimonials = (Testimonials);


/***/ }),

/***/ 1882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* reexport */ Home; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/color-mode/dist/chakra-ui-color-mode.esm.js
var chakra_ui_color_mode_esm = __webpack_require__(949);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(8527);
// EXTERNAL MODULE: ./src/components/index.ts + 50 modules
var components = __webpack_require__(2836);
// EXTERNAL MODULE: ./src/layouts/index.ts + 20 modules
var layouts = __webpack_require__(1025);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./src/assets/lotties/chacra-heart.json
var chacra_heart_namespaceObject = JSON.parse('{"v":"4.8.0","meta":{"g":"LottieFiles AE 1.0.0","a":"","k":"","d":"","tc":"#FFFFFF"},"fr":29.9700012207031,"ip":0,"op":90.0000036657751,"w":1832,"h":652,"nm":"Comp 1","ddd":0,"assets":[],"layers":[{"ddd":0,"ind":1,"ty":4,"nm":"heart Outlines","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[900,328,0],"ix":2},"a":{"a":0,"k":[1500,1500,0],"ix":1},"s":{"a":1,"k":[{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":0,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":7,"s":[0,0,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":15,"s":[49,49,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":24,"s":[28,28,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":34,"s":[41,41,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.165,0.165,0.333],"y":[-0.299,-0.299,0]},"t":44,"s":[28,28,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":53,"s":[49,49,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":64,"s":[28,28,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":75,"s":[59,59,100]},{"i":{"x":[0.667,0.667,0.667],"y":[1,1,1]},"o":{"x":[0.333,0.333,0.333],"y":[0,0,0]},"t":83,"s":[0,0,100]},{"t":89.0000036250443,"s":[0,0,100]}],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0]],"o":[[0,0]],"v":[[-2895.874,1819.253]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"st","c":{"a":0,"k":[0.752941236309,0.90588241278,0.815686334348,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"fl","c":{"a":0,"k":[0.047058999305,0.254901990704,0.043137000589,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[19.335,0],[0,0],[0,0],[25.686,46.818],[43.709,27.953],[53.444,2.07],[49.037,-29.533],[27.157,-48.148],[2.912,-6.067],[-4.318,2.477],[0,0],[-4.317,-2.477],[45.176,31.639],[57.1,2.137],[47.349,-26.04],[27.922,-43.806],[2.05,-52.362],[-0.303,-7.379],[0,0],[0,0],[0.716,-8.095],[-3.201,-20.255],[-24.435,-47.266],[-23.148,-30.123],[-30.678,-30.293],[-47.661,-41.384],[-62.89,-51.3],[-9.226,-7.499],[-6.855,5.573],[-64,54.943],[-46.331,44.915],[-25.295,30.29],[-20.064,34.997],[-10.923,55.944],[1.803,25.063],[0.029,0.328],[8.617,0],[-0.718,-8.116],[0.124,-5.169],[0.529,-6.043],[0.462,-3.796],[0.124,-0.996],[0.524,-3.542],[0.363,-2.278],[6.917,-21.49],[5.258,-12.867],[-0.235,0.557],[0.36,-0.836],[0.744,-1.683],[1.803,-3.836],[3.643,-6.978],[22.594,-29.172],[29.653,-29.199],[47.438,-41.147],[62.285,-50.806],[9.226,-7.5],[0,0],[63.413,54.388],[46.17,44.639],[24.966,29.419],[19.561,33.815],[7.08,15.112],[1.528,3.444],[0.73,1.693],[0.358,0.839],[1.061,2.596],[2.538,6.936],[4.671,23.794],[0.761,4.784],[0.316,2.152],[0.309,2.493],[0.15,1.245],[0.385,7.085],[-0.013,7.55],[-0.029,0.325],[0,0],[0,0],[0.334,8.125],[-1.42,13.395],[-1.287,7.209],[-1.507,6.048],[-4.429,11.305],[-3.02,6.404],[-3.111,5.601],[-6.94,9.566],[-4.51,5.439],[-4.4,4.657],[-20.443,12.928],[-47.936,1.591],[-44.969,-27.412],[-24.828,-51.723],[-4.949,0],[0,0],[-2.233,4.651],[-41.075,28.432],[-51.751,1.615],[-12.748,-1.34],[-7.207,-1.28],[-6.454,-1.62],[-11.305,-4.428],[-1.398,-0.563],[-4.496,-1.989],[-2.717,-1.283],[-5.668,-3.155],[-9.633,-7.016],[-5.427,-4.52],[-4.657,-4.42],[-12.842,-20.372],[-7.461,-26.603],[-1.309,-6.335],[-0.577,-3.449],[-0.224,-1.486],[-0.139,-0.993],[-0.234,-1.83],[0.615,-14.999],[-7.858,0],[0,0]],"o":[[0,0],[0,0],[2.192,-53.422],[-24.975,-45.523],[-45.071,-28.824],[-57.296,-2.219],[-47.34,28.51],[-3.306,5.862],[4.317,-2.477],[0,0],[4.318,2.477],[-23.907,-49.805],[-46.755,-32.746],[-54.068,-2.023],[-45.552,25.051],[-28.157,44.174],[-0.288,7.381],[0,0],[0,0],[-8.637,0],[-1.822,20.593],[8.327,52.687],[17.453,33.76],[26.297,34.22],[44.92,44.355],[61.285,53.214],[9.212,7.515],[6.8,5.528],[65.447,-53.202],[48.954,-42.027],[28.308,-27.444],[25.845,-30.949],[28.285,-49.335],[4.778,-24.472],[-0.024,-0.328],[-0.714,-8.07],[-7.561,0],[0.456,5.158],[-0.146,6.064],[-0.334,3.81],[-0.121,0.996],[-0.435,3.484],[-0.337,2.281],[-3.549,22.301],[-4.26,13.235],[-1.101,2.695],[-0.354,0.839],[-0.727,1.691],[-1.714,3.876],[-3.349,7.124],[-17.191,32.93],[-25.518,32.945],[-44.752,44.065],[-60.724,52.671],[-9.213,7.516],[0,0],[-64.822,-52.694],[-48.741,-41.803],[-27.718,-26.798],[-25.167,-29.655],[-8.356,-14.446],[-1.599,-3.412],[-0.748,-1.685],[-0.361,-0.837],[-0.68,-1.597],[-2.793,-6.836],[-8.328,-22.767],[-0.934,-4.754],[-0.342,-2.148],[-0.569,-3.876],[-0.155,-1.244],[-0.849,-7.045],[-0.41,-7.561],[0.001,-0.326],[0,0],[0,0],[7.863,0],[-0.553,-13.455],[0.637,-6.014],[1.096,-6.136],[2.934,-11.781],[2.152,-5.493],[2.731,-5.795],[5.74,-10.33],[3.921,-5.406],[4.09,-4.931],[17.326,-18.342],[41.325,-26.135],[52.737,-1.751],[48.313,29.449],[2.233,4.651],[0,0],[4.949,0],[22.196,-46.24],[43.418,-30.052],[12.812,-0.399],[6.124,0.644],[6.551,1.163],[11.775,2.956],[1.403,0.55],[4.564,1.839],[2.748,1.215],[5.867,2.77],[10.414,5.797],[5.403,3.935],[4.933,4.11],[18.236,17.305],[15.08,23.924],[1.747,6.229],[0.708,3.425],[0.248,1.483],[0.149,0.992],[-0.201,-1.5],[1.705,14.909],[-0.333,8.105],[0,0],[19.303,0]],"v":[[551.688,-215.88],[551.65,-215.88],[566.65,-200.88],[529.979,-354.536],[424.488,-466.896],[273.34,-514.199],[109.718,-471.345],[-4.872,-353.623],[-14.179,-335.719],[-1.227,-343.148],[-1.285,-343.148],[11.667,-335.719],[-94.769,-459.99],[-254.559,-514.224],[-410.328,-476.798],[-522.707,-371.059],[-569.255,-223.003],[-569.162,-200.88],[-554.162,-215.88],[-554.201,-215.88],[-569.201,-200.88],[-564.815,-138.48],[-513.344,12.419],[-451.971,108.275],[-365.681,203.993],[-226.356,332.192],[-39.522,488.325],[-11.863,510.845],[9.35,510.845],[204.075,349.258],[347.505,219.318],[429.095,133.776],[498.581,34.899],[559.78,-124.214],[566.759,-199.896],[566.688,-200.88],[551.688,-215.88],[536.688,-200.88],[536.934,-185.312],[535.892,-167.146],[534.695,-155.736],[534.32,-152.75],[534.334,-152.885],[533.308,-146.043],[517.391,-80.263],[502.986,-41.163],[502.928,-41.005],[501.856,-38.493],[499.65,-33.432],[494.373,-21.865],[483.881,-0.709],[423.597,93.073],[339.599,185.103],[200.863,312.511],[15.796,467.112],[-11.863,489.633],[9.35,489.633],[-183.54,329.618],[-326.406,200.426],[-406.581,117.094],[-473.993,21.836],[-497.19,-22.513],[-501.88,-32.797],[-504.097,-37.863],[-505.175,-40.377],[-505.499,-41.163],[-513.553,-61.793],[-533.275,-131.734],[-535.821,-146.043],[-536.792,-152.495],[-536.783,-152.371],[-537.253,-156.104],[-539.13,-177.305],[-539.272,-199.896],[-539.201,-200.88],[-554.201,-185.88],[-554.162,-185.88],[-539.162,-200.88],[-537.938,-241.159],[-535.721,-256.542],[-531.814,-274.824],[-520.748,-309.498],[-514.641,-323.589],[-505.874,-340.689],[-486.832,-370.568],[-477.404,-382.703],[-464.666,-397.09],[-410.603,-441.792],[-274.271,-484.256],[-125.999,-444.609],[-14.237,-320.578],[-1.285,-313.148],[-1.227,-313.148],[11.725,-320.578],[108.711,-435],[253.737,-484.282],[292.141,-482.849],[308.126,-480.565],[327.641,-476.388],[362.306,-465.293],[366.503,-463.611],[368.465,-462.781],[376.673,-459.062],[393.981,-450.172],[424.086,-430.924],[436.268,-421.411],[450.658,-408.611],[495.081,-354.67],[527.204,-282.75],[531.791,-263.897],[533.719,-253.584],[534.427,-249.131],[534.859,-246.153],[534.91,-245.658],[536.65,-200.88],[551.65,-185.88],[551.688,-185.88]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.752941236309,0.90588241278,0.815686334348,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1501.257,1499.588],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 1","np":2,"cix":2,"bm":0,"ix":2,"mn":"ADBE Vector Group","hd":false},{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[0,0],[0,3.833],[160.01,0],[45.741,-95.947],[0,0],[116.989,0],[0,-153.795],[-0.16,-3.795],[0,0],[-203.317,-199.467],[-170.158,-138.309],[-92.44,92.623]],"o":[[0,0],[0.16,-3.795],[0,-153.795],[-116.989,0],[0,0],[-45.743,-95.947],[-160.011,0],[0,3.833],[0,0],[0,0],[92.44,92.623],[170.159,-138.309],[203.317,-199.467]],"v":[[552.945,-201.292],[552.906,-201.292],[553.207,-212.721],[263.484,-499.827],[0.03,-328.561],[-0.028,-328.561],[-263.482,-499.827],[-553.207,-212.721],[-552.905,-201.292],[-552.944,-201.292],[-365.983,180.873],[0,499.827],[365.984,180.873]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[1,1,1,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[1500,1500],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Group 2","np":2,"cix":2,"bm":0,"ix":3,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":90.0000036657751,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 1","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[896,328,0],"ix":2},"a":{"a":0,"k":[0,0,0],"ix":1},"s":{"a":0,"k":[100,100,100],"ix":6}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[0,0],[-509.622,55.273],[-80,-4]],"o":[[0,0],[461,-50],[80,4]],"v":[[-874,-40],[-7,-18],[890,22]],"c":false},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"tm","s":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":70,"s":[0]},{"t":90.0000036657751,"s":[100]}],"ix":1},"e":{"a":1,"k":[{"i":{"x":[0.667],"y":[1]},"o":{"x":[0.333],"y":[0]},"t":0,"s":[0]},{"t":20.0000008146167,"s":[100]}],"ix":2},"o":{"a":0,"k":0,"ix":3},"m":1,"ix":2,"nm":"Trim Paths 1","mn":"ADBE Vector Filter - Trim","hd":false},{"ty":"st","c":{"a":0,"k":[0.752941236309,0.90588241278,0.815686334348,1],"ix":3},"o":{"a":0,"k":100,"ix":4},"w":{"a":0,"k":12,"ix":5},"lc":1,"lj":1,"ml":4,"bm":0,"nm":"Stroke 1","mn":"ADBE Vector Graphic - Stroke","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":4,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":90.0000036657751,"st":0,"bm":0}],"markers":[]}');
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
// EXTERNAL MODULE: ./node_modules/react-lottie-player/dist/LottiePlayer.modern.js
var LottiePlayer_modern = __webpack_require__(9185);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
;// CONCATENATED MODULE: ./src/page-components/home/Home.tsx









var DynamicFeaturedArticles = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 9265));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9265)
            ];
        }
    }
});
var DynamicFeaturedProjects = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1510));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(1510)
            ];
        }
    }
});
var DynamicHeroBanner = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 4033));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4033)
            ];
        }
    }
});
var DynamicOurServices = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 7209));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(7209)
            ];
        }
    }
});
var DynamicOurValues = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 6445));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6445)
            ];
        }
    }
});
var DynamicTestimonials = (0,dynamic["default"])(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3521));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(3521)
            ];
        }
    }
});
var Home = function(props) {
    var ref = (0,react.useState)(false), playChacraHeart = ref[0], setPlayChacraHeart = ref[1];
    var setColorMode = (0,chakra_ui_color_mode_esm/* useColorMode */.If)().setColorMode;
    (0,react.useEffect)(function() {
        setColorMode('light');
    }, [
        setColorMode
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* MainLayout */.Zn, {
        noPaddingTop: true,
        noHeaderLogo: true,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(head["default"], {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                    children: "Chacra Software"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicHeroBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* Section2 */.vV, {
                h: "70vh",
                fontSize: {
                    base: '2xl',
                    md: '3xl'
                },
                textAlign: "center",
                color: "darkgreen",
                mt: 40,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            base: 'none',
                            md: 'block'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                            as: "strong",
                                            children: "Founded in 2018"
                                        }),
                                        ", Chacra Software"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "is the premier software services provider"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "in the MENA Region"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            md: 'none'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                        as: "strong",
                                        children: "Founded in 2018"
                                    }),
                                    ", Chacra Software is the premier software services provider in the MENA Region"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicOurServices, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* Section2 */.vV, {
                fontSize: {
                    base: '2xl',
                    md: '3xl',
                    lg: '4xl'
                },
                textAlign: "center",
                color: "darkgreen",
                fontWeight: "medium",
                h: {
                    base: '80vh',
                    md: '100vh'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            base: 'none',
                            md: 'block'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "It's personal."
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "When our partners engage us,"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "we consider their project our own."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            md: 'none'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                children: [
                                    "It's personal.",
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                    "When our partners engage us, we consider their project our own."
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicFeaturedProjects, {
                projects: props.projects
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* Section2 */.vV, {
                fontSize: {
                    base: '2xl',
                    md: '3xl',
                    lg: '4xl'
                },
                textAlign: "center",
                color: "darkgreen",
                fontWeight: "medium",
                h: {
                    base: '80vh',
                    md: '100vh'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            base: 'none',
                            md: 'block'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "Our passion, drive, and purpose"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "are to elevate our partners"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "ideas to their highest potential."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            md: 'none'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                children: "Our passion, drive, and purpose are to elevate our partners ideas to their highest potential."
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicOurValues, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* Section2 */.vV, {
                fontSize: {
                    base: 'lg',
                    md: '2xl',
                    lg: '3xl'
                },
                textAlign: "center",
                color: "darkgreen",
                h: {
                    base: '40vh',
                    md: 'max-content'
                },
                my: {
                    base: '10',
                    md: '48',
                    lg: '48'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            base: 'none',
                            md: 'block'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Our partners"
                                        }),
                                        " experience tremendous success"
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "when working with us. See what"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "they say about us"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            md: 'none'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Our partners"
                                    }),
                                    " experience tremendous success when working with us. See what they say about us"
                                ]
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicTestimonials, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(layouts/* Section */.$0, {
                fontSize: {
                    base: 'lg',
                    md: '2xl',
                    lg: '3xl'
                },
                textAlign: "center",
                color: "darkgreen",
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-around",
                alignItems: "center",
                h: {
                    base: '60vh',
                    md: 'max-content'
                },
                my: {
                    base: '20',
                    md: '48',
                    lg: '48'
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            base: 'none',
                            md: 'block'
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                            children: "Giving back"
                                        }),
                                        " is at the core of our identity."
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "We offer special rates to charities and NGOs"
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Text */.xv, {
                                    children: "that work hard to improve our community."
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(chakra_ui_layout_esm/* Box */.xu, {
                        display: {
                            md: 'none'
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* FadeUpMask */.qt, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(chakra_ui_layout_esm/* Text */.xv, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "Giving back"
                                    }),
                                    " is at the core of our identity. We offer special rates to charities and NGOs that work hard to improve our community."
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(components/* MotionBox */.uH, {
                        pt: {
                            base: '0px',
                            lg: '130px'
                        },
                        viewport: {
                            once: true,
                            amount: 'all'
                        },
                        onViewportEnter: function() {
                            return setPlayChacraHeart(true);
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LottiePlayer_modern/* default */.Z, {
                            animationData: chacra_heart_namespaceObject,
                            play: playChacraHeart,
                            loop: false,
                            segments: [
                                0,
                                66
                            ]
                        })
                    })
                ]
            }),
            props.posts && /*#__PURE__*/ (0,jsx_runtime.jsx)(DynamicFeaturedArticles, {
                posts: props.posts
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/page-components/home/FeaturedArticles/FeaturedArticles.tsx
var FeaturedArticles = __webpack_require__(9265);
// EXTERNAL MODULE: ./src/page-components/home/FeaturedProjects/FeaturedProjects.tsx + 2 modules
var FeaturedProjects = __webpack_require__(1510);
// EXTERNAL MODULE: ./src/page-components/home/HeroBanner/HeroBanner.tsx + 1 modules
var HeroBanner = __webpack_require__(4033);
// EXTERNAL MODULE: ./src/page-components/home/OurServices/OurServices.tsx
var OurServices = __webpack_require__(7209);
// EXTERNAL MODULE: ./src/page-components/home/OurValues/OurValues.tsx + 1 modules
var OurValues = __webpack_require__(6445);
// EXTERNAL MODULE: ./src/page-components/home/Testimonials/Testimonials.tsx + 1 modules
var Testimonials = __webpack_require__(3521);
;// CONCATENATED MODULE: ./src/page-components/home/index.ts








;// CONCATENATED MODULE: ./src/pages/index.tsx
var __N_SSG = true;



/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [445,13,234,296,5,4,394,965,25,774,888,179], function() { return __webpack_exec__(5301); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);